import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PostAskRequest } from 'domain/usecases';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';
import { makeRemotePostQueueRequest } from 'main/factories/usecases';
import { AskRequest } from '@hone-automation/common';
import { invalidateQueueRequestsForLocation } from './queueQueryKeys';

export const useCreateQueueRequestMutation = (locationId: string, setActiveTransaction: (trx: AskRequest) => void) => {
  const queryClient = useQueryClient();
  const createAskRequests = makeRemotePostQueueRequest();

  return useMutation({
    mutationFn: async (data: PostAskRequest.Body) => {
      return createAskRequests.post(data);
    },
    onSuccess: async data => {
      const request = data as AskRequest;

      // Invalidate old query key format (used by useQueueRequestsQuery)
      await queryClient.invalidateQueries({ queryKey: ['queueRequests', request.status, locationId] });
      // Invalidate new query key format (used by useGetQueueRequestsQuery in QueueContext)
      invalidateQueueRequestsForLocation(queryClient, locationId);
      await queryClient.invalidateQueries({ queryKey: ['queueRequestsCount', locationId] });

      setActiveTransaction(request);
      showToast('Request created successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },
    onError: (e: Error) => {
      showToast(e.message, TOAST_ERROR, TEN_SECONDS);
    },
  });
};
